import * as logClient from "@classdojo/log-client";
import React from "react";

type AudioProps = {
  src: string;
  isPlaying: boolean;
  onPlaying?: VoidFunction;
  onPause?: VoidFunction;
  onEnded?: VoidFunction;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class Audio extends React.Component<AudioProps> {
  componentDidUpdate(prevProps: AudioProps) {
    const isSameSong = prevProps.src === this.props.src;
    if (this.audioNode && isSameSong) {
      if (this.props.isPlaying) {
        this.audioNode.play().catch(() => {
          logClient.sendMetrics([
            {
              type: "increment",
              value: 1,
              metricName: "toolkit.media.audio.play.error",
            },
          ]);
        });
      } else {
        this.audioNode.pause();
      }
    }
  }

  render() {
    const { src, isPlaying, onPlaying, onPause, onEnded } = this.props;
    return (
      <audio
        src={src}
        autoPlay={isPlaying}
        ref={(node) => (this.audioNode = node)}
        onPlaying={onPlaying}
        onPause={onPause}
        onEnded={onEnded}
      />
    );
  }

  audioNode: HTMLAudioElement | null;
}
